import {
  setAccounts,
  setCurrentAccount,
  setLoading,
  setError,
} from "../slices/accountSlice";

export const fetchUserAccounts = () => async (dispatch) => {
  try {
    dispatch(setLoading());

    const response = await fetch("/api/accounts/user", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Could not fetch accounts");
    }

    dispatch(setAccounts(data));
    return data;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  }
};

export const fetchAccountDetails = (accountId) => async (dispatch) => {
  try {
    dispatch(setLoading());
    
    const response = await fetch(`/api/accounts/${accountId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to fetch account details');
    }

    dispatch(setCurrentAccount(data));
  } catch (error) {
    console.error('Account fetch error:', error);
    dispatch(setError(error.message));
  }
}; 